export const ORDER_TYPES = ['Renuevo', 'STC']
